import { render, staticRenderFns } from "./ContractDetailTvvTable.vue?vue&type=template&id=6816915a&scoped=true"
import script from "./ContractDetailTvvTable.vue?vue&type=script&lang=js"
export * from "./ContractDetailTvvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6816915a",
  null
  
)

export default component.exports